import maryamPic from "@/public/images/artists/maryam.png";
import { Artist } from "@/types/types";

export const maryam = {
  id: "228",
  name: "Maryam",
  image: maryamPic,
  description: `Maryam's mezzo-soprano voice is captivating, with a resonant vibrato and impressive control across her range. Her clarity and brightness give her an ethereal quality, making her perfect for both operatic roles and cinematic soundtracks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmaryam-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Classical", "Soundtrack", "Ethereal"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 76,
      },
      sweetSpot: 69,
    },
  },
} as const satisfies Artist;
